module.exports = __webpack_public_path__ + "static/img/TRAVIS_HEAD.16ebf02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TRAVIS_HEAD.jpg
// module id = WtYR
// module chunks = 0